<template>
  <header class="header" :class="{ white: white }">
    <div class="container">
      <router-link class="logo" :to="{ path: '/' }">
        <img :src="$baseURL + logo" />
      </router-link>
      <nav :class="{ check }">
        <li>
          <router-link :to="{ path: '/' }">HOME
            <i class="iconfont icon-tuxingxia"></i>
          </router-link>
        </li>
        <li class="menu">
          <router-link :to="{ path: '/about' }" :class="{ kai: menu[0] }">ABOUT
            <i class="iconfont icon-tuxingxia"></i>
            <div class="app_click" @click="kais(0, $event)"></div>
          </router-link>
          <div class="menu_sxl" :class="{ show: menu[0] }">
            <div class="title">
              <div class="en">ABOUT HAIMA</div>
              <!-- <div class="cn">关于海玛</div> -->
            </div>
            <ul>
              <router-link :to="{ path: '/about/js' }">Company Introduction</router-link>
              <router-link :to="{ path: '/about/zz' }">Honor</router-link>
              <router-link :to="{ path: '/about/lc' }">Development History</router-link>
              <router-link :to="{ path: '/about/hb' }">Cooperative Partner</router-link>
            </ul>
          </div>
        </li>
        <li class="menu">
          <router-link :to="{ path: '/product' }" :class="{ kai: menu[1] }">PRODUCTS
            <i class="iconfont icon-tuxingxia"></i>
            <div class="app_click" @click="kais(1, $event)"></div>
          </router-link>
          <div class="menu_sxl" :class="{ show: menu[1] }">
            <div class="title">
              <div class="en">HAIMA PRODUCTS</div>
              <!-- <div class="cn">海玛产品</div> -->
            </div>
            <ul>
              <router-link v-for="item in top.product_cats" :key="item.id"
                :to="{ path: '/product/list', query: { cid: item.id } }">{{ item.cat_name }}</router-link>
            </ul>
          </div>
        </li>
        <li class="menu">
          <router-link :to="{ path: '/solution' }" :class="{ kai: menu[2] }">SOLUTION
            <i class="iconfont icon-tuxingxia"></i>
            <div class="app_click" @click="kais(2, $event)"></div>
          </router-link>
          <div class="menu_sxl" :class="{ show: menu[2] }">
            <div class="title">
              <div class="en">HAIMA SOLUTION</div>
              <!-- <div class="cn">解决方案</div> -->
            </div>
            <ul>
              <router-link v-for="item in top.solutionlist" :key="item.id"
                :to="{ path: '/solution', query: { id: item.id } }">{{ item.title }}</router-link>
            </ul>
          </div>
        </li>
        <li class="menu">
          <router-link :to="{ path: '/case' }" :class="{ kai: menu[3] }">CASE
            <i class="iconfont icon-tuxingxia"></i>
            <div class="app_click" @click="kais(3, $event)"></div>
          </router-link>
          <div class="menu_sxl" :class="{ show: menu[3] }">
            <div class="title">
              <div class="en">HAIMA CASE</div>
              <!-- <div class="cn">经典案例</div> -->
            </div>
            <ul>
              <router-link v-for="item in top.case_industry" :key="item.id"
                :to="{ path: '/case/list', query: { cid: item.id } }">{{ item.title }}</router-link>
            </ul>
          </div>
        </li>
        <li class="menu">
          <router-link :to="{ path: '/news' }" :class="{ kai: menu[4] }">NEWS
            <i class="iconfont icon-tuxingxia"></i>
            <div class="app_click" @click="kais(4, $event)"></div>
          </router-link>
          <div class="menu_sxl" :class="{ show: menu[4] }">
            <div class="title">
              <div class="en">HAIMA NEWS</div>
              <!-- <div class="cn">媒体中心</div> -->
            </div>
            <ul>
              <router-link v-for="item in top.news_cats" :key="item.id"
                :to="{ path: '/news/list', query: { cid: item.id } }">{{ item.cat_name }}</router-link>
            </ul>
          </div>
        </li>
        <li class="menu">
          <router-link :to="{ path: '/countact' }" :class="{ kai: menu[5] }">CONTACT
            <i class="iconfont icon-tuxingxia"></i>
            <div class="app_click" @click="kais(5, $event)"></div>
          </router-link>
          <div class="menu_sxl" :class="{ show: menu[5] }">
            <div class="title">
              <div class="en">CONTACT US</div>
              <!-- <div class="cn">联系我们</div> -->
            </div>
            <ul>
              <router-link :to="{ path: '/countact/ln' }">Talent Concept</router-link>
              <router-link :to="{ path: '/countact/zp' }">Recruiting</router-link>
              <router-link :to="{ path: '/countact/lx' }">Contact Us</router-link>
            </ul>
          </div>
        </li>
        <li>
          <a href="http://hmagvs.com">
            <i class="iconfont icon-tuxingxia"></i>
            CN
          </a>
        </li>
      </nav>

      <div class="app_right">
        <a href="http://hmagvs.com">CN</a>

        <div @click="check = !check" class="app_nav_btn" :class="{ check }">
          <span></span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    logo: {
      type: String,
    },
    top: {
      type: Object,
    },
  },
  data() {
    return {
      white: false,
      check: false,
      menu: [false, false, false, false, false, false],
    };
  },
  methods: {
    /* 页面滚动监听 */
    watchScroll() {
      window.addEventListener("scroll", () => {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop > 49) {
          this.white = true;
        } else {
          this.white = false;
        }
      });
    },
    kais(i, e) {
      if (document.documentElement.clientWidth < 1000) {
        this.menu[i] = !this.menu[i];
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    },
  },
  mounted() {
    this.watchScroll();
  },
  watch: {
    $route(to, from) {
      this.check = false;
      this.menu = [false, false, false, false, false, false];
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100%;
  text-align: center;
  line-height: 80px;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      width: 40vmin;
      max-width: 130px;
      filter: grayscale(1000000%) brightness(10000%);

      &>img {
        width: 100%;
      }
    }

    nav {
      flex: 1;
      display: flex;
      justify-content: space-between;
      margin: 0 0 0 19vw;
      transition: all 0.3s;

      li {
        &>a {
          color: #fff;
          display: block;
          font-size: 16px;
          transition: all 0.3s;
          position: relative;

          .app_click {
            width: 20px;
            height: 20px;
            position: absolute;
            right: 8px;
            top: 16px;
            z-index: 2;
          }

          .iconfont {
            font-size: 12px;
            color: var(--themeColor);
            position: absolute;
            left: 50%;
            bottom: -35%;
            transform: translateX(-50%) translateY(-20%);
            opacity: 0;
            transition: all 0.3s;
          }

          &:hover,
          &.router-link-active {
            color: var(--themeColor) !important;

            .iconfont {
              opacity: 1;
              transform: translateX(-50%);
            }
          }
        }

        .menu_sxl {
          width: 100vw;
          z-index: 99;
          display: none;
          position: absolute;
          left: 50%;
          top: 80px;
          transform: translateX(-50%);
          line-height: 1.7;
          background: #fff;
          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);

          .title {
            width: 42%;
            background: var(--themeColor);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #fff;

            .en {
              font-size: 40px;
              font-weight: 600;
              line-height: 1.2;
            }

            .cn {
              font-size: 16px;
            }
          }

          ul {
            padding: 100px;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: 20px;

            a {
              // margin-right: 150px;
              color: var(--themeColor);
            }
          }
        }

        @media (min-width: 1000px) {
          &:hover {
            .menu_sxl {
              display: flex;
              animation: show_sxl 1s;
            }
          }
        }
      }
    }

    .app_right {
      display: none;
      align-items: center;

      /* 移动端菜单按钮 */
      .app_nav_btn {
        width: 50px;
        height: 50px;
        transform: scale(0.7) translateX(50%);

        & span,
        &::after,
        &::before {
          content: "";
          display: block;
          width: 70%;
          height: 3px;
          border-radius: 2px;
          background: #fff;
          position: absolute;
          left: 0;
          transition: all 0.3s;
        }

        &::after {
          transform-origin: right center;
          top: 25%;
        }

        &::before {
          transform-origin: right center;
          top: 75%;
        }

        & span {
          top: 50%;
        }

        &.check span {
          opacity: 0;
        }

        &.check::after {
          transform: rotate(-46deg);
        }

        &.check::before {
          transform: rotate(46deg);
        }
      }

      a {
        color: white;
      }
    }
  }

  &.white {
    background-color: #fff;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);

    .container {
      .logo {
        filter: none;
      }

      nav {
        li>a {
          color: #333;
        }
      }

      .app_right {
        a {
          color: #333;
        }

        .app_nav_btn {

          & span,
          &::after,
          &::before {
            background: #333;
          }
        }
      }
    }
  }
}

@keyframes show_sxl {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes hide_sxl {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@media (max-width: 1000px) {
  .header {
    line-height: 60px;

    .container {
      height: 60px;

      /* 移动端顶部导航处理 */
      .app_right {
        display: flex;
      }

      nav {
        position: fixed;
        top: 60px;
        left: 100%;
        z-index: 999;
        background: var(--themeColor);
        display: block;
        line-height: 50px;
        transition: all 0.3s;
        width: calc(100vw - 20px);
        height: calc(100vh - 60px);
        padding: 0 10px;
        margin: 0;

        &.check {
          left: 0;
        }

        &>li {
          height: auto;

          &>a {
            color: #fff !important;
            position: static;
            transform: translate(0);
            border-bottom: 1px solid #eee;
            position: relative;

            &:hover,
            &.router-link-active {
              color: #fff !important;

              .iconfont {
                opacity: 1;
                transform: translateX(-50%);
              }
            }

            .iconfont {
              display: none;
            }
          }

          &.menu>a {

            &::after,
            &::before {
              position: absolute;
              top: 50%;
              left: auto;
              right: 10px;
              content: "";
              width: 15px;
              height: 2px;
              background-color: #ddd;
              transition: all 0.3s;
            }

            &::after {
              transform: rotate(90deg);
            }

            &.kai::before,
            &.kai::after {
              transform: rotate(360deg);
            }
          }

          .menu_sxl {
            position: sticky;
            transform: none;
            width: auto;
            background: none;
            box-shadow: none;

            &.show {
              display: block;
            }

            .title {
              display: none;
            }

            ul {
              width: 100%;
              display: block;
              padding: 20px 0;

              a {
                line-height: 2;
                text-align: center;
                display: block;
                color: #fff !important;
                margin: 0;
                height: auto;
              }
            }
          }
        }
      }
    }
  }
}
</style>